import React from 'react';
import ReactDOM from 'react-dom/client';
import reactToWebComponent from 'react-to-webcomponent';
import '../style/index.scss';

function Expose(components) {
  for (const component of components) {
    if (customElements.get(component.tag) == null) {
      component.element.propTypes = component.attributes;
      customElements.define(
        component.tag,
        reactToWebComponent(component.element, React, ReactDOM, {
          dashStyleAttributes: true,
        })
      );
    }
  }

  if (document && document.currentScript) {
    const src = document.currentScript.src;
    const params = src.indexOf('?') < 0 ? {} : src.split('?')[1].split('&');
    let args = {};

    const keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      const param = params[i];
      const [key, value] = param.split('=');
      args[key] = value;
    }

    // eslint-disable-next-line no-prototype-builtins
    if (args.tag && components.find((c) => c.tag === args.tag)) {
      const el = document.createElement('div');
      el.innerHTML = `<${args.tag}></${args.tag}>`;
      document.currentScript.parentNode.insertBefore(
        el,
        document.currentScript.nextSibling
      );
    }
  }
}

export default Expose;
